"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.MapGeo = exports.mapDistance = exports.sortLocations = void 0;
var distance_1 = require("@turf/distance");
var sortLocations = function (locations) {
    return locations.sort(function (a, b) {
        //the following two lines make missing distances (-1) go to last position
        if (a.distance < 0)
            return 1;
        if (b.distance < 0)
            return -1;
        if (a.distance > b.distance) {
            return 1;
        }
        if (a.distance < b.distance) {
            return -1;
        }
        return a.name.localeCompare(b.name); //compare names
        //return 0; // a must be equal to b
    });
};
exports.sortLocations = sortLocations;
var distanceOptions = { units: "kilometers" /*incorrect US spelling of metric value*/ };
var mapDistance = function (locations, searchResults, selectedLocationId, closestLocationId) { return exports.sortLocations(locations.map(function (location) {
    var geo = {
        type: "Point",
        coordinates: [
            location.longitude,
            location.latitude,
        ]
    };
    var canDistance = searchResults && location.longitude && location.latitude;
    var isHovered = selectedLocationId === location.id;
    var isClosest = closestLocationId === location.id;
    return __assign(__assign({}, location), { distance: canDistance ? Math.round(distance_1["default"](searchResults, geo, distanceOptions) * 10) / 10 : -1, isHovered: isHovered, isClosest: isClosest });
})); };
exports.mapDistance = mapDistance;
var MapGeo = function (locations) {
    var result = [];
    locations.forEach(function (location) {
        var geo = {
            type: "Point",
            coordinates: [
                location.longitude,
                location.latitude,
            ]
        };
        var store = {
            type: "Feature",
            geometry: geo,
            properties: {
                id: location.id,
                name: location.name,
                address: location.address,
                website: location.url,
                city: location.city,
                address2: location.address2,
                postcode: location.postcode,
                state: location.state
            }
        };
        result.push(store);
    });
    return {
        type: "FeatureCollection",
        features: result
    };
};
exports.MapGeo = MapGeo;
